import type { Nullable } from '../../fp/nullable';
import { type Branded, brand } from '../Branded';

export type OptionalString = Branded<Nullable<string>, 'optionalString'>;

export function asOptionalString(
  value: string | undefined | null,
): OptionalString {
  return brand<OptionalString>(value);
}

export function emptyString(): OptionalString {
  return brand<OptionalString>(null);
}
